import { render, staticRenderFns } from "./TableTambahan.vue?vue&type=template&id=e99ff60c"
import script from "./TableTambahan.vue?vue&type=script&lang=js"
export * from "./TableTambahan.vue?vue&type=script&lang=js"
import style0 from "./TableTambahan.vue?vue&type=style&index=0&id=e99ff60c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports